import { useState } from "react";
import { X } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";

export default function ChangePasswordModal({ onClose }) {
    const [current, setCurrent] = useState("");
    const [next, setNext] = useState("");
    const [confirm, setConfirm] = useState("");
    const [error, setError] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        if (next.length < 8) return setError("New password must be at least 8 characters.");
        if (next !== confirm) return setError("New passwords do not match.");
        setBusy(true);
        try {
            await api.post("/api/auth/change-password", { current_password: current, new_password: next });
            toast.success("Password changed successfully");
            onClose();
        } catch (err) {
            setError(apiError(err));
        } finally {
            setBusy(false);
        }
    };

    const field =
        "mt-1.5 w-full rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-sm font-medium text-ink outline-none transition-colors focus:border-brand-blue/50";

    return (
        <div
            className="fixed inset-0 z-[90] flex items-center justify-center bg-ink/50 p-4 backdrop-blur-sm"
            onClick={onClose}
            data-testid="change-password-modal"
        >
            <div
                className="w-full max-w-sm rounded-3xl border border-slate-200 bg-white p-7 shadow-2xl"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex items-center justify-between">
                    <h2 className="text-lg font-bold tracking-tight text-ink">Change Password</h2>
                    <button
                        data-testid="change-password-close"
                        onClick={onClose}
                        aria-label="Close"
                        className="flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 text-ink/60 hover:text-ink"
                    >
                        <X size={16} />
                    </button>
                </div>
                <form onSubmit={submit} className="mt-5 space-y-4">
                    <div>
                        <label className="text-xs font-bold uppercase tracking-[0.14em] text-ink/50">Current Password</label>
                        <input data-testid="cp-current" type="password" required value={current} onChange={(e) => setCurrent(e.target.value)} className={field} />
                    </div>
                    <div>
                        <label className="text-xs font-bold uppercase tracking-[0.14em] text-ink/50">New Password</label>
                        <input data-testid="cp-new" type="password" required minLength={8} value={next} onChange={(e) => setNext(e.target.value)} className={field} />
                    </div>
                    <div>
                        <label className="text-xs font-bold uppercase tracking-[0.14em] text-ink/50">Confirm New Password</label>
                        <input data-testid="cp-confirm" type="password" required minLength={8} value={confirm} onChange={(e) => setConfirm(e.target.value)} className={field} />
                    </div>
                    {error && (
                        <p data-testid="cp-error" className="rounded-xl border border-red-200 bg-red-50 px-4 py-2.5 text-sm font-semibold text-red-600">
                            {error}
                        </p>
                    )}
                    <button
                        data-testid="cp-submit"
                        type="submit"
                        disabled={busy}
                        className="btn-gradient inline-flex w-full items-center justify-center rounded-full px-6 py-3 text-sm font-bold text-white disabled:opacity-60"
                    >
                        {busy ? "Updating…" : "Update Password"}
                    </button>
                </form>
            </div>
        </div>
    );
}
